export default {
  quest: {
    fetching: false,
    fetched: false,
    submitting: false,
    submitted: false,
    data: null
  }
}
